import React, { Component } from 'react';
import { connect } from 'react-redux';
import { mountTabulatorReduce } from '../actions';
import { connection_platform } from '../services/api';
import axios from 'axios';

var port = localStorage.getItem('port');
var pathname = localStorage.getItem('pathname');

const mapStateToProps = state => {
    return {
      InfoUsers: state.informationusers
    };
  };

const mapDispatchToProps = dispatch => ({
    mountTabulatorReduce: (array) => {
        dispatch(mountTabulatorReduce(array))
      }
  })
  

 class MountTabulator extends Component {
        constructor(props) {
            super(props);
            this.state = {user: props.InfoUsers ? props.InfoUsers : ''};
            
        }

    async getSubcategoryTree(idfather, namefather) {
    const { user } = this.state;
    let aux = idfather;
    let temp = true;
    let children = [];
    try {
        while (temp) {
          const retorno = await axios.get(`${connection_platform.type_connect}://${pathname}:${port}/conn/gettabulatorfathersec?groupid=${user.idgroup}&idfather=${aux}`)
            if(retorno.status === 200){
                    let data = retorno.data;
                    if (data.length !== 0) {
                      temp = true;
                      for (let i = 0; i < data.length; i++) {
                        if (aux !== data[i].subcatid) {
                          let getSubcat = await this.getSubcategoryTree(data[i].subcatid)
                          if (getSubcat.length !== 0) {
                            children.push({
                              value: data[i].subcatid,
                              label: data[i].desc_subcat,
                              children: getSubcat,
                              className: "dropdownd-three-childrens",
                            })
                          } else {
                            children.push({
                              value: data[i].subcatid,
                              label: data[i].desc_subcat,
                            })
                          }
                        } else {
                          children[children.length - 1].children.push({
                            value: data[i].subcatid,
                            label: data[i].desc_subcat
                          })
                        }
                        aux = data[i].subcatid;
                      }

                    } else {
                      temp = false;
                    }
              }
    
        }
    } catch (error) {
      console.log("ERRO_TABULATOR : ",error)      
    }
  
    return children;
  }

  async componentDidMount() {

    port = localStorage.getItem('port');
    pathname = localStorage.getItem('pathname');


    
    const { user } = this.state;

    if(user.idgroup !== undefined){

        const retorno = await axios.get(`${connection_platform.type_connect}://${pathname}:${port}/conn/gettabulatorfatherpri?groupid=${user.idgroup}`)

        let array = [];
        let data = retorno.data;
        let categoryid = 0;
        if(data.length!==0){
        for (let i = 0; i < data.length; i++) {

          if (categoryid !== data[i].categoryid) {
            let getSubcat = await this.getSubcategoryTree(data[i].subcatid, data[i].desc_subcat)
            if (getSubcat.length !== 0) {
              array.push({
                value: data[i].categoryid,
                label: data[i].desc_category,
                className: "dropdownd-three-childrens",
                children: [
                  {
                    value: data[i].subcatid,
                    label: data[i].desc_subcat,
                    className: "dropdownd-three-childrens",
                    children: getSubcat,
                  }
                ]
              })
            } else {
              array.push({
                value: data[i].categoryid,
                label: data[i].desc_category,
                className: "dropdownd-three-childrens",
                children: [
                  {
                    value: data[i].subcatid,
                    label: data[i].desc_subcat
                  }
                ]
              })
            }
          } else {
            let getSubcat = await this.getSubcategoryTree(data[i].subcatid, data[i].desc_subcat)
            if (getSubcat.length !== 0) {
              array[array.length - 1].children.push({
                value: data[i].subcatid,
                label: data[i].desc_subcat,
                children: getSubcat,
                className: "dropdownd-three-childrens"
              })
            } else {
              array[array.length - 1].children.push({
                value: data[i].subcatid,
                label: data[i].desc_subcat,
              })
            }
          }
          categoryid = data[i].categoryid;
        }
      }
        this.props.mountTabulatorReduce(array)

    }
    
  }


render(){
   
        return(
            <div/>
        )
  }
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
  )(MountTabulator);